


































































































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { PageComponentVue } from '@/base'
import {
  pageStore,
  appStore,
  alertStore,
  modalErrorStore,
  bibliographySearchStore,
  bibliographyDetailSetStore,
  bibliographyDetailStore,
  authUserStore,
  traderStore,
  dataStore,
  modalJobListStore,
  donorStore,
  systemCodeStore,
  systemParameterStore
} from '@/store'
import { BibliographyTagDataList } from '@/components/templates/bibliography-tag-data-list'
import BibliographyDetailSetVolumeList from '@/components/templates/detail-set/BibliographyDetailSetVolumeList.vue'
import CollectionMagazineNameVolumePossessionInfoTable from '@/components/templates/collection-magazine-name-volume-possession-info/CollectionMagazineNameVolumePossessionInfoTable.vue'
import CollectionMagazineNameMarcTable from '@/components/templates/collection-magazine-name-marc/CollectionMagazineNameMarcTable.vue'
import {
  Alert,
  AlertMessage,
  bibliographyApi,
  BibliographySearchListDetail,
  BibliographySearchResultItem,
  bibliographySetApi,
  BibliographySetDetail,
  BibliographySetDetailAuthority,
  BibliographySetDetailAutoOrder,
  BibliographySetDetailBibliography,
  BibliographySetDetailDetail,
  BibliographySetDetailMarc,
  BibliographySetDetailVolume,
  BibliographySetManagementInfo,
  defaultBibliographySetDetail,
  defaultBibliographySetDetailAutoOrder,
  defaultBibliographySetDetailBibliography,
  defaultBibliographySetManagementInfo,
  defaultSystemCode,
  ErrorMessage,
  FirstMarcLabel,
  jobApi,
  marcLabelApi,
  SystemCode
} from '@/api'
import BibliographySetInfo from '@/components/organisms/BibliographySetInfo/BibliographySetInfo.vue'
import SearchResultPagination from '@/components/molecules/SearchResultPagination/SearchResultPagination.vue'
import ModalBibliographyIntegration from '@/components/modals/ModalBibliographyIntegration/ModalBibliographyIntegration.vue'
import {
  AlertCodeALC00007,
  AlertCodeALC00012,
  BibliographyClass,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullIdWithMarcNo,
  Prefix,
  SearchType
} from '@/types'
import { AlertFactory } from '@/factory'
import {
  DATA_STORE_FETCHED,
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import { cloneDeep, isEqual } from 'lodash'
import { ModalBibliographyTagDataEditOkItem } from '@/store/ModalBibliographyTagDataEditStore'
import {
  BibliographyDetailVolumeTableDisplayBranchCode,
  BibliographyDetailVolumeTableItem,
  defaultBibliographyDetailVolumeTableItem,
  defaultBibliographyDetailVolumeTableDisplayBranchCode,
  BibliographyDetailVolumeTableItemRow
} from '@/components/organisms/BibliographyDetailVolumeTable'
import {
  defaultFirstBibliographyInfo,
  FirstTransitionToBibliographyDetail,
  SecondAfterTransitionToBibliographyDetail
} from '@/store/BibliographyDetailStore'
import {
  CollectionMagazineManagementInfo,
  CollectionMagazineManagementInfoItem,
  defaultCollectionMagazineManagementInfoItem
} from '@/components/templates/collection-magazine-management-info'
import { defaultSortColumn } from '@/components/molecules/DataTable'
import { CODE_KEY } from '@/config'
import { ModalAutoOrderEdit } from '@/components/modals/ModalAutoOrderEdit'
import ModalCallNumberEdit from '@/components/modals/ModalCallNumberEdit/ModalCallNumberEdit.vue'
import {
  AutoOrderTable,
  defaultAutoOrderTableItem,
  AutoOrderTableItem
} from '@/components/organisms/AutoOrderTable'
import { ModalAutoOrderBulkEdit } from '@/components/modals/ModalAutoOrderBulkEdit'
import { footerType } from '@/types/footer.type'

export interface BibliographySetDetailItem {
  bibliography: BibliographySetDetailBibliography
  volume: BibliographyDetailVolumeTableItem
  details: BibliographySetDetailDetail[]
  authorities: BibliographySetDetailAuthority[]
  autoOrderInfo: AutoOrderTableItem
  marcs: BibliographySetDetailMarc[]
  managementInfo: BibliographySetManagementInfo
}

export const defaultBibliographySetDetailItem = (): BibliographySetDetailItem => ({
  bibliography: defaultBibliographySetDetailBibliography(),
  volume: defaultBibliographyDetailVolumeTableItem(),
  details: [],
  authorities: [],
  autoOrderInfo: defaultAutoOrderTableItem(),
  marcs: [],
  managementInfo: defaultBibliographySetManagementInfo()
})

@Component({
  components: {
    ModalAutoOrderBulkEdit,
    AutoOrderTable,
    ModalCallNumberEdit,
    ModalAutoOrderEdit,
    CollectionMagazineManagementInfo,
    ModalBibliographyIntegration,
    SearchResultPagination,
    BibliographySetInfo,
    BibliographyTagDataList,
    CollectionMagazineNameVolumePossessionInfoTable,
    CollectionMagazineNameMarcTable,
    BibliographyDetailSetVolumeList
  }
})
export default class DetailSet extends PageComponentVue {
  @Ref()
  modalBibliographyIntegration!: ModalBibliographyIntegration

  @Ref()
  modalAutoOrderEdit!: ModalAutoOrderEdit

  @Ref()
  modalAutoOrderBulkEdit!: ModalAutoOrderBulkEdit

  activeTab: BibliographyDetailSetTabType = BibliographyDetailSetTabType.Volume

  bibliographySetDetail: BibliographySetDetail = defaultBibliographySetDetail()

  tabItem: BibliographySetDetailItem = defaultBibliographySetDetailItem()

  tableBodyHeight: number = 0

  firstMarcLabels: FirstMarcLabel[] = []

  displayBranchCode: BibliographyDetailVolumeTableDisplayBranchCode = defaultBibliographyDetailVolumeTableDisplayBranchCode()

  currentPage: number = 0

  managementInfoInputItem: CollectionMagazineManagementInfoItem = defaultCollectionMagazineManagementInfoItem()

  isFetchingBibliographySetDetail: boolean = false

  get enableManagementInfo(): boolean {
    return dataStore.enableManagementInfo
  }

  get showPagination(): boolean {
    return (
      bibliographyDetailStore.showPagination && this.searchResultsCount !== 0
    )
  }

  get firstBibliographyInfo(): BibliographyFullIdWithMarcNo {
    return bibliographyDetailStore.firstBibliographyInfo
  }

  get secondAfterTransitionSource(): SecondAfterTransitionToBibliographyDetail {
    return bibliographyDetailStore.secondAfterTransitionSource
  }

  get tabType(): any {
    return BibliographyDetailSetTabType
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get pageTitle(): string {
    return '資料の管理：照会（雑誌・誌名）'
  }

  get searchType(): SystemCode {
    return { ...defaultSystemCode(), code: SearchType.Magazine }
  }

  get filterSearchResults(): BibliographySearchResultItem[] {
    return bibliographySearchStore.filterItems
  }

  get searchResults(): BibliographySearchResultItem[] {
    const notExistsSearchResultsByBibliographyDetailSet = bibliographySearchStore.items.every(
      searchResult =>
        searchResult.prefix !== Prefix.Set &&
        searchResult.bibliographyId !== this.tabItem.bibliography.bibliographyId
    )

    if (
      notExistsSearchResultsByBibliographyDetailSet &&
      this.secondAfterTransitionSource ===
        SecondAfterTransitionToBibliographyDetail.Volume
    ) {
      return []
    } else {
      return this.filterSearchResults
    }
  }

  get searchResultsCount(): number {
    return this.searchResults.length
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  get existsVolumes(): boolean {
    return this.tabItem.volume.rows.length > 0
  }

  get existsAutoOrderInfo(): boolean {
    return this.bibliographySetDetail.autoOrders.some(
      autoOrder => autoOrder.orderNumber > 0 || autoOrder.donatedNumber > 0
    )
  }

  get isTransitionPined(): boolean {
    return bibliographyDetailStore.isTransitionPined
  }

  @Watch('isTransitionPined')
  onChangeIsTransitionPined(): void {
    this.setLeftFooterAction()
  }

  // 同じ書誌に遷移してペジネーションを非表示にする場合もあり得る（ピン留め履歴等）のでこちらで計算を行うように修正する
  @Watch('showPagination')
  onChangeShowPagination(): void {
    this.calculateTableHeight()
  }

  // HACK どこで何をしているか完全に分かるならwatch処理は削除したほうが望ましい
  @Watch('existsVolumes')
  onChangeVolumes(): void {
    this.setRightFooterActions()
  }

  // HACK watchはどこで何が起きているのか判断し辛いので余裕があれば削除したい
  // HACK routeのwatchなので削除できる
  @Watch('$route.query.page', { immediate: true })
  onChangeQueryPage(): void {
    if (this.$route.name === 'bibliographies-detail-set') {
      this.currentPage = Number(this.$route.query?.page ?? 0)
    }
  }

  // HACK watchはどこで何が起きているのか判断し辛いので余裕があれば削除したい
  // HACK routeのwatchなので削除できる
  @Watch('$route.query.id', { immediate: true })
  onChangeRouteId() {
    if (this.$route.name === 'bibliographies-detail-set') {
      this.fetchBibliographySetDetail()
      this.setLeftFooterAction()
    }
  }

  // HACK watchはどこで何が起きているのか判断し辛いので余裕があれば削除したい
  // HACK routeのwatchなので削除できる
  @Watch('$route.hash', { immediate: true })
  onChangeRouteHash() {
    if (this.$route.name === 'bibliographies-detail-set') {
      this.$nextTick(() => {
        this.activeTab = [
          BibliographyDetailSetTabType.Volume,
          BibliographyDetailSetTabType.MagazineName,
          BibliographyDetailSetTabType.AutoOrder,
          BibliographyDetailSetTabType.Marc,
          BibliographyDetailSetTabType.Management
        ].includes(location.hash.substr(1))
          ? location.hash.substr(1)
          : BibliographyDetailSetTabType.Volume
      })
    }
  }

  asyncData(): void {
    traderStore.fetchAll()
    donorStore.fetchAll()
    systemCodeStore.fetchAllByCodeKeys([CODE_KEY.LIBRARY_BRANCH.KEY])
    systemParameterStore.fetchAllByCodeKeys([
      CODE_KEY.CALL_CONCATENATION_NUMBER_INSTRUCTION.KEY
    ])
  }

  created(): void {
    // リロード時の初期書誌設定処理、物理書誌照会で既に設定済みであれば何もしない
    if (isEqual(this.firstBibliographyInfo, defaultFirstBibliographyInfo())) {
      bibliographyDetailStore.setFirstBibliographyInfo({
        prefix: this.$route.query.prefix
          ? (this.$route.query.prefix as Prefix)
          : Prefix.Real,
        id: this.$route.query.id ? Number(this.$route.query.id) : undefined,
        marcNo: this.$route.query.marc_no
          ? (this.$route.query.marc_no as string)
          : undefined,
        title: this.$route.query.title
          ? (this.$route.query.title as string)
          : undefined
      })
    }

    this.$eventBus.on(DATA_STORE_FETCHED, () =>
      this.$nextTick(this.setRightFooterActions)
    )
  }

  activated() {
    this.setPageTitle()
    this.setLeftFooterAction()
    this.setRightFooterActions()
    window.addEventListener('resize', this.onResize)

    this.$nextTick(this.calculateTableHeight)
  }

  deactivated() {
    this.isFetchingBibliographySetDetail = false
    this.tabItem = defaultBibliographySetDetailItem()
    window.removeEventListener('resize', this.onResize)
    this.$eventBus.off(DATA_STORE_FETCHED)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0
    this.$nextTick(() => {
      const pageCollection: HTMLCollection | null = document.getElementsByClassName(
        'v-main__wrap'
      ) as HTMLCollectionOf<HTMLElement>

      if (this.activeTab === BibliographyDetailSetTabType.MagazineName) {
        const contentCollection: HTMLCollection = document.getElementsByClassName(
          'tab-content'
        ) as HTMLCollectionOf<HTMLElement>

        const footer: HTMLCollection = document.getElementsByClassName(
          'v-footer'
        ) as HTMLCollectionOf<HTMLElement>

        this.tableBodyHeight =
          window.innerHeight -
          contentCollection[0].clientHeight +
          footer[0].clientHeight +
          2
        return
      }

      const deductHeight: number =
        window.innerHeight - pageCollection[0]?.clientHeight

      this.tableBodyHeight =
        window.innerHeight -
        deductHeight -
        pageCollection[0].children[0].clientHeight
    })
  }

  isActiveTab(value: BibliographyDetailSetTabType): boolean {
    return this.activeTab === value
  }

  onClickTagDataEdit(): void {
    this.$modalBibliographyTagDataEdit.open({
      isEdit: true,
      bibliographyClass: BibliographyClass.Set,
      searchType: this.searchType,
      editBibliographyId: this.tabItem.bibliography.bibliographyId,
      details: this.tabItem.details,
      authorities: this.tabItem.authorities,
      revision: this.tabItem.bibliography.revision,
      onOk: () => {
        this.fetchBibliographySetDetail()
      }
    })
  }

  onClickCopy(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00007, '誌名', '複写')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.$modalBibliographyTagDataEdit.open({
          isCopy: true,
          bibliographyClass: BibliographyClass.Set,
          searchType: this.searchType,
          details: this.tabItem.details,
          authorities: this.tabItem.authorities,
          onOk: (item: ModalBibliographyTagDataEditOkItem) => {
            bibliographyDetailStore.setSecondAfterTransitionSource(
              SecondAfterTransitionToBibliographyDetail.Copy
            )
            this.$router.push({
              path: '/bibliographies/detail-set',
              query: {
                id: String(item.bibliographyId),
                prefix: Prefix.Set,
                title: item.title
              },
              hash: `${BibliographyDetailSetTabType.Volume}`
            })
          }
        })
      }
    })
  }

  onClickDelete() {
    const alert: Alert = AlertFactory.create(
      AlertCodeALC00007,
      '集合書誌',
      '削除'
    )
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: async () => {
        this.$eventBus.emit(PAGE_LOADING_START)

        try {
          await bibliographySetApi.deleteBibliographySet(
            this.tabItem.bibliography.bibliographyId
          )
          await this.$router.push('/bibliographies')
        } catch (error) {
          if (error instanceof AlertMessage) {
            alertStore.setItems(error.alerts)
            this.$modalAlert.open()
          } else if (error instanceof ErrorMessage) {
            modalErrorStore.init(error)
            this.$modalError.open()
          } else {
            console.error(error)
          }
        } finally {
          this.$eventBus.emit(PAGE_LOADING_END)
        }
      }
    })
  }

  setPageTitle(): void {
    pageStore.setTitle(this.pageTitle)
  }

  setLeftFooterAction(): void {
    pageStore.setLeftFooterActions([
      {
        text: '検索へ',
        icon: 'arrow-left',
        disabled:
          bibliographyDetailStore.firstTransitionSource ===
          FirstTransitionToBibliographyDetail.SimpleOrdering,
        callback: () => {
          this.$router.push('/bibliographies')
        }
      },
      {
        text: '検索結果へ',
        icon: 'arrow-left',
        disabled:
          bibliographyDetailStore.disabledTransitionSearchResult ||
          this.searchResults.length === 0,
        callback: () => {
          this.$router.push('/bibliographies/search-result')
        }
      },
      {
        text: '最初の書誌へ',
        icon: 'arrow-left',
        disabled:
          bibliographyDetailStore.disabledTransitionFirstBibliography ||
          (this.$route.query.prefix === this.firstBibliographyInfo.prefix &&
            Number(this.$route.query.id) === this.firstBibliographyInfo.id),
        callback: () => {
          bibliographyDetailStore.setSecondAfterTransitionSource(
            SecondAfterTransitionToBibliographyDetail.Not
          )
          this.$router.push({
            path: `/bibliographies/detail-${
              this.firstBibliographyInfo.prefix === Prefix.Real ? 'real' : 'set'
            }`,
            query: {
              marc_no:
                this.firstBibliographyInfo.id === 0
                  ? this.firstBibliographyInfo.marcNo
                  : undefined,
              id:
                (this.firstBibliographyInfo?.id ?? 0) > 0
                  ? String(this.firstBibliographyInfo.id)
                  : undefined,
              prefix:
                (this.firstBibliographyInfo?.id ?? 0) > 0
                  ? this.firstBibliographyInfo.prefix
                  : undefined,
              title: this.firstBibliographyInfo.title,
              page: String(
                this.filterSearchResults.findIndex(
                  searchResult =>
                    searchResult.prefix + searchResult.bibliographyId ===
                    this.firstBibliographyInfo.prefix +
                      this.firstBibliographyInfo.id
                ) + 1
              )
            },
            hash: `#${
              this.firstBibliographyInfo.prefix === Prefix.Real
                ? BibliographyDetailRealTabType.Collection
                : BibliographyDetailSetTabType.Volume
            }`
          })
        }
      }
    ])
  }

  setRightFooterActions(): void {
    const actions: footerType.IAction[] = [
      {
        text: '自動発注',
        icon: '',
        disabled:
          this.isAuthUserGroupBibliographyOnlyReference ||
          !this.existsVolumes ||
          !this.existsAutoOrderInfo,
        callback: () => {
          alertStore.setItem(
            AlertFactory.create(AlertCodeALC00012, '次号の自動発注')
          )
          this.$modalAlert.open({
            onOkClick: this.autoOrder
          })
        }
      },
      {
        text: '削除',
        icon: '',
        callback: this.onClickDelete,
        disabled:
          this.isAuthUserGroupBibliographyOnlyReference || this.existsVolumes
      }
    ]

    if (dataStore.displayBibliographyDetailPageBibliographyIntegrationButton) {
      actions.push({
        text: '書誌統合',
        icon: '',
        callback: this.openModalBibliographyIntegration,
        disabled: this.isAuthUserGroupBibliographyOnlyReference
      })
    }

    pageStore.setRightFooterActions(actions)
  }

  tabClass(value: BibliographyDetailSetTabType): string {
    return this.activeTab === value ? 'active' : ''
  }

  onClickTab(value: BibliographyDetailSetTabType): void {
    if (value === this.activeTab) {
      return
    }
    location.hash = value
    this.activeTab = value
    this.setRightFooterActions()
    this.$nextTick(this.calculateTableHeight)
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onClickLink(bibliographyId: number): void {
    bibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Set
    )
    bibliographyDetailSetStore.setVolumes(
      cloneDeep(
        this.tabItem.volume.rows.map(row => ({
          prefix: row.prefix,
          bibliographyId: row.bibliographyId,
          collectionNo: row.collectionNo,
          marcNo: row.marcNo,
          bibliographyContentId: row.bibliographyContentId,
          volume: row.volume,
          volumeNumber: row.volumeNumber,
          volumeTotal: row.volumeTotal,
          volumeDateLabel: row.volumeDateLabel,
          volumeSpecial: row.volumeSpecial,
          displayContent: row.displayContent,
          continueAndLookCode: row.continueAndLookCode,
          collectionsStatus: row.collectionsStatus,
          continuationStatusName: row.continuationStatusName,
          shelfCount: row.shelfCount,
          holdingCount: row.holdingCount,
          orderCount: row.orderCount,
          reserveCount: row.reserveCount,
          revision: row.revision
        }))
      )
    )
    this.$router.push({
      path: '/bibliographies/detail-real',
      query: {
        id: String(bibliographyId),
        prefix: Prefix.Real,
        title: this.tabItem.bibliography.displayTitle,
        page: String(
          this.tabItem.volume.rows.findIndex(
            volume => volume.bibliographyId === bibliographyId
          ) + 1
        )
      },
      hash: `#${BibliographyDetailRealTabType.Content}`
    })
  }

  onClickVolume(bibliographyId: number): void {
    bibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Set
    )
    bibliographyDetailSetStore.setVolumes(
      cloneDeep(
        this.tabItem.volume.rows.map(row => ({
          prefix: row.prefix,
          bibliographyId: row.bibliographyId,
          collectionNo: row.collectionNo,
          marcNo: row.marcNo,
          bibliographyContentId: row.bibliographyContentId,
          volume: row.volume,
          volumeNumber: row.volumeNumber,
          volumeTotal: row.volumeTotal,
          volumeDateLabel: row.volumeDateLabel,
          volumeSpecial: row.volumeSpecial,
          displayContent: row.displayContent,
          continueAndLookCode: row.continueAndLookCode,
          collectionsStatus: row.collectionsStatus,
          continuationStatusName: row.continuationStatusName,
          shelfCount: row.shelfCount,
          holdingCount: row.holdingCount,
          orderCount: row.orderCount,
          reserveCount: row.reserveCount,
          revision: row.revision
        }))
      )
    )
    this.$router.push({
      path: '/bibliographies/detail-real',
      query: {
        id: String(bibliographyId),
        prefix: Prefix.Real,
        title: this.tabItem.bibliography.displayTitle,
        page: String(
          this.tabItem.volume.rows.findIndex(
            volume => volume.bibliographyId === bibliographyId
          ) + 1
        )
      },
      hash: `#${BibliographyDetailRealTabType.Bibliography}`
    })
  }

  openModalBibliographyIntegration(): void {
    this.modalBibliographyIntegration.open({
      bibliographyFullId: {
        prefix: this.tabItem.bibliography.prefix,
        id: this.tabItem.bibliography.bibliographyId
      },
      onProcessed: this.fetchBibliographySetDetail
    })
  }

  openModalAutoOrderBulkEdit(): void {
    this.modalAutoOrderBulkEdit.open({
      bibliographyId: this.bibliographySetDetail.bibliography.bibliographyId,
      rows: this.tabItem.autoOrderInfo.rows,
      onUpdated: this.fetchBibliographySetDetail
    })
  }

  openModalAutoOrderEdit(): void {
    this.modalAutoOrderEdit.open({
      bibliographyId: this.bibliographySetDetail.bibliography.bibliographyId,
      autoOrder:
        this.bibliographySetDetail.autoOrders.find(
          autoOrder =>
            autoOrder.id ===
            this.tabItem.autoOrderInfo.selectedRow().orderAutoId
        ) ??
        Object.assign(defaultBibliographySetDetailAutoOrder(), {
          orderBranchCode: this.tabItem.autoOrderInfo.selectedRow()
            .orderBranchCode
        }),
      onUpdated: this.fetchBibliographySetDetail
    })
  }

  prev(): void {
    this.pagination(this.currentPage - 2)
  }

  next(): void {
    this.pagination(this.currentPage)
  }

  pagination(index: number): void {
    if (index === -1) return

    bibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Pagination
    )

    if (this.searchResults[index].prefix === Prefix.Real) {
      this.$router.push({
        path: '/bibliographies/detail-real',
        query: {
          marc_no:
            this.firstBibliographyInfo.id === 0
              ? (this.searchResults as BibliographySearchResultItem[])[index]
                  .marcNo
              : undefined,
          id:
            (this.firstBibliographyInfo?.id ?? 0) > 0
              ? String(this.searchResults[index].bibliographyId)
              : undefined,
          prefix:
            (this.firstBibliographyInfo?.id ?? 0) > 0 ? Prefix.Real : undefined,
          title: this.searchResults[index].displayTitle,
          page: String(index + 1)
        },
        hash: `#${BibliographyDetailRealTabType.Collection}`
      })
      return
    }

    this.$router.push({
      path: '/bibliographies/detail-set',
      query: {
        id: String(this.searchResults[index].bibliographyId),
        prefix: Prefix.Set,
        title: this.searchResults[index].displayTitle,
        page: String(index + 1)
      },
      hash: `#${location.hash.substr(1)}`
    })
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  fetchBibliographySetDetail(): void {
    this.fetchBibliographySetDetailInterface(false)
  }

  fetchBibliographySetDetailOnCreatedBibliography(): void {
    this.fetchBibliographySetDetailInterface(true)
  }

  async fetchBibliographySetDetailInterface(isCreatedBibliography: boolean) {
    try {
      this.isFetchingBibliographySetDetail = true

      this.bibliographySetDetail = await bibliographySetApi.getBibliography(
        Number(this.$route.query.id)
      )

      this.tabItem = {
        bibliography: this.bibliographySetDetail.bibliography,
        volume: Object.assign(defaultBibliographyDetailVolumeTableItem(), {
          rows: this.bibliographySetDetail.volumes.map(
            (volume: BibliographySetDetailVolume, index: number) => {
              let isSelected: boolean

              if (
                this.tabItem.bibliography.bibliographyId !==
                Number(this.$route.query.id)
              ) {
                isSelected = index === 0
              } else if (isCreatedBibliography) {
                // 作成した書誌を洗い出しているわけではなく、単に最も新しい巻号を取得するようにしている
                // 厳密に対応する場合はAPIで作成したIDをレスポンスでフロント側に返却する等の対応が必要だと思われるがそこまでの意義は薄いと判断
                const newestBibliographyId = Math.max(
                  ...this.bibliographySetDetail.volumes.map(
                    volume => volume.bibliographyId
                  )
                )

                isSelected = newestBibliographyId === volume.bibliographyId
              } else {
                isSelected =
                  this.tabItem.volume.selectedRow().bibliographyId ===
                  volume.bibliographyId
              }

              return {
                isSelected,
                ...volume
              }
            }
          ),
          sortColumn:
            this.tabItem.bibliography.bibliographyId ===
            Number(this.$route.query.id)
              ? this.tabItem.volume.sortColumn
              : defaultSortColumn()
        }),
        details: this.bibliographySetDetail.details,
        authorities: this.bibliographySetDetail.authorities,
        autoOrderInfo: Object.assign(defaultAutoOrderTableItem(), {
          rows: systemCodeStore.getLibraryBranch.map(
            (systemCode: SystemCode, index: number) => {
              let autoOrderInfo: BibliographySetDetailAutoOrder = defaultBibliographySetDetailAutoOrder()
              autoOrderInfo.orderBranchCode = systemCode
              let isSelected: boolean

              for (const autoOrder of this.bibliographySetDetail.autoOrders) {
                if (autoOrder.orderBranchCode.code === systemCode.code) {
                  autoOrderInfo = autoOrder
                  break
                }
              }

              if (
                this.tabItem.bibliography.bibliographyId !==
                Number(this.$route.query.id)
              ) {
                isSelected = index === 0
              } else {
                isSelected =
                  this.tabItem.autoOrderInfo.selectedRow().orderBranchCode
                    .code === systemCode.code
              }

              return {
                isSelected,
                orderAutoId: autoOrderInfo.id || null,
                orderBranchCode: autoOrderInfo.orderBranchCode,
                orderNumber: {
                  input: String(autoOrderInfo.orderNumber),
                  errorMessage: ''
                },
                traderCode: {
                  input: autoOrderInfo.traderCode.code,
                  display: autoOrderInfo.traderCode.shortName,
                  errorMessage: ''
                },
                acceptType: {
                  input: autoOrderInfo.acceptType.code,
                  display: autoOrderInfo.acceptType.shortName,
                  errorMessage: ''
                },
                buyDepartmentCode: {
                  input: autoOrderInfo.buyDepartmentCode.code,
                  display: autoOrderInfo.buyDepartmentCode.shortName,
                  errorMessage: ''
                },
                donatedNumber: {
                  input: String(autoOrderInfo.donatedNumber),
                  errorMessage: ''
                },
                donorCode: {
                  input: autoOrderInfo.donorCode.code,
                  display: autoOrderInfo.donorCode.shortName,
                  errorMessage: ''
                },
                budgetYear: {
                  input: String(autoOrderInfo.budgetYear || ''),
                  errorMessage: ''
                },
                budgetBranchCode: {
                  input: autoOrderInfo.budgetBranchCode.code,
                  display: autoOrderInfo.budgetBranchCode.shortName,
                  errorMessage: ''
                },
                budgetDepartmentCode: {
                  input: autoOrderInfo.budgetDepartmentCode.code,
                  display: autoOrderInfo.budgetDepartmentCode.shortName,
                  errorMessage: ''
                },
                budgetItem: {
                  input: autoOrderInfo.budgetItem.code,
                  display: autoOrderInfo.budgetItem.shortName,
                  errorMessage: ''
                },
                equipType: {
                  input: autoOrderInfo.equipType.code,
                  display: autoOrderInfo.equipType.shortName,
                  errorMessage: ''
                },
                collectionType: {
                  input: autoOrderInfo.collectionType.code,
                  display: autoOrderInfo.collectionType.shortName,
                  errorMessage: ''
                },
                shelfType: {
                  input: autoOrderInfo.shelfType.code,
                  display: autoOrderInfo.shelfType.shortName,
                  errorMessage: ''
                },
                handlingType: {
                  input: autoOrderInfo.handlingType.code,
                  display: autoOrderInfo.handlingType.shortName,
                  errorMessage: ''
                },
                storeType: {
                  input: autoOrderInfo.storeType.code,
                  display: autoOrderInfo.storeType.shortName,
                  errorMessage: ''
                },
                storingLimitCode: {
                  input: autoOrderInfo.storingLimitCode.code,
                  display: autoOrderInfo.storingLimitCode.shortName,
                  errorMessage: ''
                },
                mark: {
                  input: autoOrderInfo.mark,
                  errorMessage: ''
                },
                ndc: {
                  input: autoOrderInfo.ndc,
                  errorMessage: ''
                },
                book: {
                  input: autoOrderInfo.book,
                  errorMessage: ''
                },
                sub: {
                  input: autoOrderInfo.sub,
                  errorMessage: ''
                },
                revision: autoOrderInfo.revision || null
              }
            }
          )
        }),
        marcs: this.bibliographySetDetail.marcs,
        managementInfo: this.bibliographySetDetail.managementInfo
      }

      this.managementInfoInputItem = {
        bibliographySetId: this.tabItem.bibliography.marcNo,
        maxBibliographyRealId: this.tabItem.volume.rows.reduce(
          (accum: string, current: BibliographyDetailVolumeTableItemRow) =>
            current.marcNo > accum ? current.marcNo : accum,
          ''
        ),
        contractYear: {
          input: this.tabItem.managementInfo.contractYear,
          errorMessage: ''
        },
        continuation: {
          input: this.tabItem.managementInfo.continuation
        },
        openBookbinding: {
          input: this.tabItem.managementInfo.openBookbinding
        },
        bookClaim: {
          input: this.tabItem.managementInfo.bookClaim
        },
        needBookbinding: {
          input: this.tabItem.managementInfo.needBookbinding
        },
        notArrived: {
          input: this.tabItem.managementInfo.notArrived
        },
        traderCode: {
          input: this.tabItem.managementInfo.traderCode.code,
          errorMessage: ''
        },
        donorCode: {
          input: this.tabItem.managementInfo.donorCode.code,
          errorMessage: ''
        },
        shelfPlace: {
          input: this.tabItem.managementInfo.shelfPlace,
          errorMessage: ''
        },
        memo7: {
          input: this.tabItem.managementInfo.memo7,
          errorMessage: ''
        },
        holdingYear: {
          input: this.tabItem.managementInfo.holdingYear,
          errorMessage: ''
        },
        holdingVolume: {
          input: this.tabItem.managementInfo.holdingVolume,
          errorMessage: ''
        },
        missingNumberText: {
          input: this.tabItem.managementInfo.missingNumberText,
          errorMessage: ''
        },
        memo3: {
          input: this.tabItem.managementInfo.memo3,
          errorMessage: ''
        },
        memo4: {
          input: this.tabItem.managementInfo.memo4,
          errorMessage: ''
        },
        memo2: {
          input: this.tabItem.managementInfo.memo2,
          errorMessage: ''
        },
        retitleBefore: {
          input: this.tabItem.managementInfo.retitleBefore,
          errorMessage: ''
        },
        retitleAfter: {
          input: this.tabItem.managementInfo.retitleAfter,
          errorMessage: ''
        },
        memo1: {
          input: this.tabItem.managementInfo.memo1,
          errorMessage: ''
        },
        memo6: {
          input: this.tabItem.managementInfo.memo6,
          errorMessage: ''
        },
        memo5: {
          input: this.tabItem.managementInfo.memo5,
          errorMessage: ''
        }
      }

      await this.fetchMarcLabel()
      await this.getBibliographySearchListDetail()

      this.setRightFooterActions()
      this.isFetchingBibliographySetDetail = false
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async fetchMarcLabel(): Promise<void> {
    try {
      this.firstMarcLabels = await marcLabelApi.getAll(
        BibliographyClass.Set,
        { ...defaultSystemCode(), code: SearchType.Magazine },
        false
      )
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async getBibliographySearchListDetail(displayBranchCode?: SystemCode) {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.isFetchingBibliographySetDetail = true

      // 繰り返し中に「bibliographySetDetail」が書き換わる可能性がある為、参照を変数に格納して処理する
      const tempReference: BibliographySetDetailItem = this.tabItem

      const loopCount = Math.ceil(this.tabItem.volume.rows.length) / 100
      let start: number = 0
      let end: number = 100

      for (let i = 0; i <= loopCount; i++) {
        if (
          !this.existsVolumes ||
          this.tabItem !== tempReference ||
          start > tempReference.volume.rows.length - 1
        ) {
          return
        }

        if (end > tempReference.volume.rows.length) {
          end = tempReference.volume.rows.length
        }

        const bibliographies = tempReference.volume.rows
          .slice(start, end)
          .map(volume => {
            return {
              prefix: volume.prefix,
              id: volume.bibliographyId
            }
          })

        const responses: BibliographySearchListDetail[] = await bibliographyApi.getBibliographySearchListDetail(
          {
            bibliographies,
            displayBranchCode: displayBranchCode ?? defaultSystemCode()
          }
        )

        tempReference.volume.rows.forEach(volume => {
          const targetResponse:
            | BibliographySearchListDetail
            | undefined = responses.find(
            response =>
              response.prefix === volume.prefix &&
              response.bibliographyId === volume.bibliographyId
          )

          if (targetResponse !== undefined) {
            volume.collectionNo = targetResponse.collectionNo
            volume.collectionsStatus.shortName = targetResponse.collectionStatus
            volume.continuationStatusName =
              targetResponse.continuationStatusName
            volume.shelfCount = targetResponse.shelfCount
            volume.holdingCount = targetResponse.holdingCount
            volume.orderCount = targetResponse.orderCount
            volume.reserveCount = targetResponse.reserveCount
          }
        })

        start += 100
        end += 100
      }

      this.isFetchingBibliographySetDetail = false
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (displayBranchCode) {
          this.setErrorMessage(error.alerts, this.displayBranchCode)
        }
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async updateBibliographySetManagementInfo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographySetApi.updateBibliographySetManagementInfo({
        id: this.tabItem.managementInfo.id,
        bibliographySetId: this.tabItem.bibliography.bibliographyId,
        continuation: this.managementInfoInputItem.continuation.input,
        notArrived: this.managementInfoInputItem.notArrived.input,
        openBookbinding: this.managementInfoInputItem.openBookbinding.input,
        bookClaim: this.managementInfoInputItem.bookClaim.input,
        shelfPlace: this.managementInfoInputItem.shelfPlace.input,
        traderCode: this.managementInfoInputItem.traderCode.input,
        donorCode: this.managementInfoInputItem.donorCode.input,
        missingNumberText: this.managementInfoInputItem.missingNumberText.input,
        retitleBefore: this.managementInfoInputItem.retitleBefore.input,
        retitleAfter: this.managementInfoInputItem.retitleAfter.input,
        contractYear: this.managementInfoInputItem.contractYear.input,
        holdingYear: this.managementInfoInputItem.holdingYear.input,
        holdingVolume: this.managementInfoInputItem.holdingVolume.input,
        needBookbinding: this.managementInfoInputItem.needBookbinding.input,
        memo1: this.managementInfoInputItem.memo1.input,
        memo2: this.managementInfoInputItem.memo2.input,
        memo3: this.managementInfoInputItem.memo3.input,
        memo4: this.managementInfoInputItem.memo4.input,
        memo5: this.managementInfoInputItem.memo5.input,
        memo6: this.managementInfoInputItem.memo6.input,
        memo7: this.managementInfoInputItem.memo7.input,
        revision: this.tabItem.managementInfo.revision
      })

      this.fetchBibliographySetDetail()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.managementInfoInputItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  createMagazineBookNumberList(): void {
    this.$eventBus.emit(PAGE_LOADING_START)

    const createMagazineBookNumberList = async () => {
      try {
        const jobId = await jobApi.createMagazineBookNumberList({
          bibliographySetId: Number(this.$route.query.id),
          searchList: this.tabItem.volume.rows.map(volume => {
            return {
              bibliographyRealId: volume.bibliographyId,
              collectionNo: volume.collectionNo,
              collectionStatusName:
                volume.collectionsStatus.shortName !== ''
                  ? volume.collectionsStatus.shortName
                  : volume.continuationStatusName,
              shelfCount: volume.shelfCount,
              holdingCount: volume.holdingCount,
              orderCount: volume.orderCount,
              reserveCount: volume.reserveCount
            }
          })
        })

        await modalJobListStore.newJobId(jobId)
      } catch (error) {
        if (error instanceof AlertMessage) {
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      } finally {
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    }

    if (this.isFetchingBibliographySetDetail) {
      const unwatch = this.$watch('isFetchingBibliographySetDetail', () => {
        createMagazineBookNumberList().finally(unwatch)
      })
      return
    }

    createMagazineBookNumberList()
  }

  async autoOrder(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographySetApi.autoOrder({
        id: Number(this.$route.query.id)
      })

      this.fetchBibliographySetDetailOnCreatedBibliography()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
